// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"2eb3e3c86151a07f0508","339":"cc7cf63659ee97d0aa27"}[chunkId] + ".js";
};